/** @format */

import {Box, Button} from '@mui/material';
import {styled} from '@mui/material/styles';
import {clsx} from 'clsx';
import {Trans, useTranslation} from 'react-i18next';

import {providerNewIconSrc} from 'helpers/imageHelpers';

import {OauthProvider as Provider} from 'graphql/generated/types';

import {AD_PROVIDERS} from '../../constants';

const PREFIX = 'PROVIDER_TABS';

const classes = {
  wrapper: `${PREFIX}-wrapper`,
  button: `${PREFIX}-button`,
  buttonActive: `${PREFIX}-buttonActive`,
  buttonIcon: `${PREFIX}-buttonIcon`,
  label: `${PREFIX}-label`,
};

const StyledBox = styled(Box)(({theme}) => ({
  [`& .${classes.label}`]: {
    marginTop: theme.spacing(4),
    color: '#F1F1F1',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  [`& .${classes.wrapper}`]: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  [`& .${classes.button}`]: {
    flex: 1,
    padding: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
    height: '53px',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    background: '#202020',
    borderRadius: '0',
    textTransform: 'none',
    '&:hover': {
      background: '#4D4D4D',
    },
    '&:first-of-type': {
      borderRadius: '8px 0 0 8px',
    },
    '&:last-of-type': {
      borderRadius: '0 8px 8px 0',
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      borderRadius: '0 !important',
    },
  },
  [`& .${classes.buttonActive}`]: {
    background: '#4D4D4D',
  },
  [`& .${classes.buttonIcon}`]: {
    width: 21,
    height: 21,
    marginRight: theme.spacing(2),
  },
}));

interface Props {
  activeProvider: Provider | null;
  onProviderClick: (provider: Provider | null) => void;
}

const ProviderTabs = ({activeProvider, onProviderClick}: Props) => {
  const {t} = useTranslation();

  const providerImage = (v: Provider) => providerNewIconSrc(v, 20);
  const providerName = (v: Provider) => t(`provider_names.${v}`);

  return (
    <StyledBox>
      <Box className={classes.label}>
        <Trans>Выберите рекламную систему</Trans>
      </Box>

      <Box className={classes.wrapper}>
        {AD_PROVIDERS.map((provider: Provider) => (
          <Button
            className={clsx(classes.button, activeProvider === provider && classes.buttonActive)}
            key={provider}
            onClick={() => onProviderClick(provider)}
          >
            <img
              alt={providerName(provider)}
              src={providerImage(provider)}
              className={classes.buttonIcon}
            />
            {providerName(provider)}
          </Button>
        ))}
        <Button
          className={clsx(classes.button, !activeProvider && classes.buttonActive)}
          onClick={() => onProviderClick(null)}
        >
          <Trans>Не добавлять</Trans>
        </Button>
      </Box>
    </StyledBox>
  );
};

export default ProviderTabs;
